import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Errore di rete";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmtMoney(n) {
  if (n == null || isNaN(n)) return "—";
  const v = Math.round(Number(n));
  return new Intl.NumberFormat("it-IT", { maximumFractionDigits: 0 }).format(v);
}

// Resolve logo reference to a displayable URL.
// Accepts either full URL, or an upload_id from /api/uploads/{id}.
export function logoSrc(ref) {
  if (!ref) return null;
  if (typeof ref !== "string") return null;
  if (ref.startsWith("http://") || ref.startsWith("https://") || ref.startsWith("/")) return ref;
  return `${API}/uploads/${ref}`;
}
